import { useMemo } from 'react'
import { useAppointment } from '@/v2/hooks/useAppointment'
import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

export const useLoadData = appointmentId => {
  const {
    data: dataRooms,
    isLoading: loadingRooms,
    isError: errorRooms,
  } = useQuery({
    queryKey: ['Rooms'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/rooms`)
      if (!res.ok) {
        throw new Error('Failed to fetch rooms')
      }
      return await res.json()
    },
  })

  const {
    data: dataDoctors,
    isLoading: loadingDoctors,
    isError: errorDoctors,
  } = useQuery({
    queryKey: ['Doctors'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/doctors`)
      if (!res.ok) {
        throw new Error('Failed to fetch doctors')
      }
      return await res.json()
    },
  })

  const {
    appointment: dataAppointment,
    isLoading: loadingAppointment,
    isError: errorAppointment,
  } = useAppointment({ appointmentId })

  const loading = loadingRooms || loadingDoctors || loadingAppointment
  const error = errorRooms || errorDoctors || errorAppointment

  const rooms = dataRooms || []
  const doctors = dataDoctors || []
  const appointment = dataAppointment || {}

  return useMemo(() => ({ loading, error, rooms, doctors, appointment }), [
    loading,
    error,
    rooms,
    doctors,
    appointment,
  ])
}
